module.exports = "<div class=\"deploy deploy-email license-m\" connectqa-deploy-modal=\"web-app-device\">\n    <div class=\"content-wrapper\">\n        <div class=\"circle-loader mb30 m-auto\"></div>\n\n        <h2 class=\"text-xl text-grey-2 measure m-auto\"\n                translate=\"cw.deploy.modal.web-app.title\"\n                translate-values=\"{product: '{{webAppDeploymentCtrl.app.attributes.resource.oeName}}' }\"\n        ></h2>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/deployment/web-app-deployment/web-app-deployment.html
// module id = oNKH
// module chunks = 0